import { Center, Checkbox, Divider, Stack, Text } from '@mantine/core'
import { Link } from '@remix-run/react'

export const TermPrivacyCheck = () => {
  return (
    <>
      <Stack>
        <Center>
          <Text fw='bold'>
            ここまでの入力情報を登録します。下記にご同意の上、チェックを入れ「登録」ボタンを押してください。
          </Text>
        </Center>
        <Center>
          <Text fw='bold'>
            利用規約は
            <Link
              to='https://terms.inglewood.co.jp/j1gb5f-_6225/terms-of-service/'
              target='_blank'
            >
              こちら
            </Link>
          </Text>
          <Divider orientation='vertical' mx={'md'} />
          <Text fw='bold'>
            個人情報の取り扱いについては
            <Link
              to='https://terms.inglewood.co.jp/x050syg6m51/privacy-policy/'
              target='_blank'
            >
              こちら
            </Link>
          </Text>
        </Center>
        <Center>
          <Checkbox
            required
            size='md'
            label={
              <Text fw='bold'>利用規約と個人情報の取り扱いに同意する</Text>
            }
          />
        </Center>
      </Stack>
    </>
  )
}
